import { AlertCircle, ArrowCircleDown, ArrowCircleRight, ArrowCircleUpRight } from '@untitledui/icons';
import { Icon } from '../../../components/general/Icon';
import { getVehicleStatusBackgroundColor, getVehicleStatusForegroundColor } from '../../../types/ui/vehicleStatus';
import { VehicleStatusCategory } from '../../../types/ui/vehicleStatusCategory';

interface VehicleStatusIconProps {
  vehicleStatusCategory: VehicleStatusCategory;
  size?: number;
}

function VehicleStatusCategoryIcon({ vehicleStatusCategory, size = 40 }: VehicleStatusIconProps) {
  const backgroundColor = getVehicleStatusBackgroundColor(vehicleStatusCategory);
  const foregroundColor = getVehicleStatusForegroundColor(vehicleStatusCategory);
  const iconSize = size / 2;

  const getIcon = () => {
    switch (vehicleStatusCategory) {
      case VehicleStatusCategory.ON_GROUND:
        return <Icon icon={ArrowCircleDown} size={iconSize} color={foregroundColor} />;
      case VehicleStatusCategory.PREFLIGHT:
        return <Icon icon={ArrowCircleUpRight} size={iconSize} color={foregroundColor} />;
      case VehicleStatusCategory.INFLIGHT_NOMINAL:
        return <Icon icon={ArrowCircleRight} size={iconSize} color={foregroundColor} />;
      case VehicleStatusCategory.INFLIGHT_FAILURE_MODE:
        return <Icon icon={AlertCircle} size={iconSize} color={foregroundColor} />;
      case VehicleStatusCategory.POSTFLIGHT:
        return <Icon icon={ArrowCircleDown} size={iconSize} color={foregroundColor} />;
    }
  };

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}
    >
      {getIcon()}
    </div>
  );
}

export default VehicleStatusCategoryIcon;
